import { render, staticRenderFns } from "./dbDrawer.vue?vue&type=template&id=4350819d&"
import script from "./dbDrawer.vue?vue&type=script&lang=js&"
export * from "./dbDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports